var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"modal-id":_vm.modalId,"modal-size":'extra-large',"modal-alignment":'top',"is-need-button-footer":false,"title":_vm.modalTitle,"preloader":_vm.preloader},on:{"submit":_vm.submit,"close-modal":_vm.closeModal}},[_c('template',{slot:"body"},[_c('app-table',{attrs:{"id":_vm.tableId,"options":_vm.options}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }